import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Logger from '@sm360/logger-sentry';
import { ConfigsService, WindowProxy } from '@sm360/widget-commons-core-services';
import {
    Account,
    UtilsService,
    EVENTS,
    AnalyticsService,
    VIRTUAL_PAGEVIEWS as PAGES,
} from '@sm360/widget-commons-general';
import { PurchaseMethods, Vehicle } from '@sm360/widget-commons-vehicle';

import SLIDER from 'trade-in/constants/slider.js';
import EstimateTradeIn from 'trade-in/components/EstimateTradeIn/EstimateTradeIn.jsx';
import TradeInCta from 'trade-in/components/TradeInCta/TradeInCta.jsx';
import RangeValue from 'trade-in/components/CanadianBlackBookEstimate/components/RangeValue.jsx';
import EstimateHeader from 'trade-in/components/CanadianBlackBookEstimate/components/EstimateHeader/EstimateHeader.jsx';

const { PurchaseMethodsActions } = PurchaseMethods;

class CanadianBlackBookEstimate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tradeInValues: props.tradeInValues,
        };

        this.logger = new Logger(this.constructor.displayName, ConfigsService.getLoggerContext());

        this.handleEstimateChange = this.handleEstimateChange.bind(this);
        this.handleRangeChange = this.handleRangeChange.bind(this);
        this.saveTradeIn = this.saveTradeIn.bind(this);
        this.dispatchTradeInCreatedEvent = this.dispatchTradeInCreatedEvent.bind(this);
    }

    componentDidMount() {
        AnalyticsService.virtualPageView(PAGES.ESTIMATED_TRADEIN_CONDITION());
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            tradeInValues: nextProps.tradeInValues,
        });
    }

    handleRangeChange(tradeInValue) {
        if (tradeInValue) {
            const tradeInValues = {
                ...this.state.tradeInValues,
                amount: UtilsService.roundValueToStepIntoRange(
                    tradeInValue,
                    SLIDER.STEP_VALUE,
                    this.state.tradeInValues.low,
                    this.state.tradeInValues.high
                ),
            };

            this.setState({
                tradeInValues,
            });
        }
    }

    dispatchTradeInCreatedEvent() {
        const $window = WindowProxy.get();
        if ($window) {
            $window.document.dispatchEvent(new Event(EVENTS.TRADEIN_CREATED));
        }
    }

    saveTradeIn() {
        this.props
            .handleEstimateChange(
                UtilsService.roundValueToStepIntoRange(
                    this.state.tradeInValues.amount,
                    SLIDER.STEP_VALUE,
                    this.state.tradeInValues.low,
                    this.state.tradeInValues.high
                )
            )
            .then(() => {
                this.dispatchTradeInCreatedEvent();
                PurchaseMethodsActions.setTradeIn(this.state.tradeInValues);
            });
    }

    handleEstimateChange(tradeInValue) {
        const { handleEstimateChange, account } = this.props;
        return handleEstimateChange(
            UtilsService.roundValueToStepIntoRange(
                tradeInValue,
                SLIDER.STEP_VALUE,
                this.state.tradeInValues.low,
                this.state.tradeInValues.high
            ),
            account
        );
    }

    render() {
        return (
            <div className="estimate-value__wrapper">
                <EstimateHeader
                    onEditVehicle={this.props.backToVehicleForm}
                    tradeInValues={this.state.tradeInValues}
                    tradeInVehicle={this.props.tradeInVehicle}
                />
                <RangeValue high={this.state.tradeInValues.high} low={this.state.tradeInValues.low} />
                <EstimateTradeIn
                    tradeInValues={this.state.tradeInValues}
                    handleRangeChange={this.handleRangeChange}
                    handleEstimateChange={this.handleEstimateChange}
                    backToVehicleForm={this.props.backToVehicleForm}
                />
                <TradeInCta
                    saveTradeIn={this.saveTradeIn}
                    goToOfficialTradeInForm={this.props.goToOfficialTradeInForm}
                    isOfficialTradeInActivated={this.props.isOfficialTradeInActivated}
                    isRenderedInModal={this.props.isRenderedInModal}
                    isShowroomV2Enabled={this.props.isShowroomV2Enabled}
                    account={this.props.account}
                />
            </div>
        );
    }
}

CanadianBlackBookEstimate.defaultProps = {
    tradeInValues: {
        amount: 0,
        high: 0,
        low: 0,
        taxesFactor: 0,
    },
    isShowroomV2Enabled: false,
    account: new Account(),
};

CanadianBlackBookEstimate.propTypes = {
    backToVehicleForm: PropTypes.func.isRequired,
    goToOfficialTradeInForm: PropTypes.func.isRequired,
    tradeInVehicle: PropTypes.instanceOf(Vehicle.TradeInVehicleModel).isRequired,
    tradeInValues: PropTypes.shape({
        amount: PropTypes.number,
        high: PropTypes.number,
        low: PropTypes.number,
        taxesFactor: PropTypes.number,
    }),
    handleEstimateChange: PropTypes.func.isRequired,
    isOfficialTradeInActivated: PropTypes.bool.isRequired,
    isRenderedInModal: PropTypes.bool.isRequired,
    isShowroomV2Enabled: PropTypes.bool,
    account: PropTypes.instanceOf(Account),
};

CanadianBlackBookEstimate.displayName = 'CanadianBlackBookEstimate';

export default CanadianBlackBookEstimate;



// WEBPACK FOOTER //
// ./src/components/CanadianBlackBookEstimate/CanadianBlackBookEstimate.jsx